const TickerItem = ({ subtitle, title }: { subtitle?: string | null; title?: string | null }) => (
  <div className="flex flex-col md:flex-row items-center gap-2 md:gap-3 text-center md:text-left">
    <span className="flex items-center justify-center w-8 h-8 rounded-2xl bg-base-content shrink-0">
      <span className="material-symbols-outlined text-brand text-lg" style={{ fontVariationSettings: "'FILL' 1" }}>
        star
      </span>
    </span>
    <div>
      <p className="font-semibold text-sm">{title}</p>
      <p className="text-xs">{subtitle}</p>
    </div>
  </div>
);

export default TickerItem;
